module.exports = __webpack_public_path__ + "static/media/loop-ideation1.3eaabd89.png";